var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              default: "",
              name: "feed",
              label: _vm.$t("messages"),
              icon: "fal fa-envelope"
            },
            slot: "title"
          }),
          _c("q-tab-pane", { style: _vm.getStyle, attrs: { name: "feed" } }, [
            _c("div", { staticClass: "row q-mb-sm" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("q-search", {
                    attrs: { "float-label": _vm.$t("search"), debounce: 500 },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              )
            ]),
            _vm.$q.platform.is.mobile
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12" },
                    [
                      _c(
                        "q-card",
                        { staticStyle: { height: "70vh" } },
                        [
                          _c(
                            "q-card-main",
                            [
                              _c(
                                "q-scroll-area",
                                { staticStyle: { height: "60vh" } },
                                [
                                  _c(
                                    "q-list",
                                    {
                                      attrs: {
                                        highlight: "",
                                        separator: "",
                                        sparse: "",
                                        "no-border": ""
                                      }
                                    },
                                    [
                                      _vm.messages.length === 0
                                        ? _c(
                                            "q-item",
                                            { attrs: { link: "" } },
                                            [
                                              _c("q-item-main", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "no_messages_found"
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._l(_vm.filteredMessages, function(
                                        message,
                                        index
                                      ) {
                                        return _c(
                                          "q-item",
                                          {
                                            key: index,
                                            class:
                                              _vm.id === message.id
                                                ? "selected"
                                                : "",
                                            attrs: { link: "" },
                                            nativeOn: {
                                              click: function($event) {
                                                return _vm.fetchMessage(message)
                                              }
                                            }
                                          },
                                          [
                                            _c("q-item-main", {
                                              attrs: {
                                                label: message.title,
                                                sublabel: _vm.fDate(
                                                  message.send_date
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.$q.platform.is.desktop
              ? _c("div", { staticClass: "row gutter-xs full-height" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-4" },
                    [
                      _c(
                        "q-card",
                        { staticClass: "full-height" },
                        [
                          _c(
                            "q-card-main",
                            { staticClass: "full-height" },
                            [
                              _c(
                                "q-scroll-area",
                                { staticClass: "full-height" },
                                [
                                  _c(
                                    "q-list",
                                    {
                                      attrs: {
                                        highlight: "",
                                        separator: "",
                                        sparse: "",
                                        "no-border": ""
                                      }
                                    },
                                    [
                                      _vm.messages.length === 0
                                        ? _c(
                                            "q-item",
                                            { attrs: { link: "" } },
                                            [
                                              _c("q-item-main", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "no_messages_found"
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._l(_vm.filteredMessages, function(
                                        message,
                                        index
                                      ) {
                                        return _c(
                                          "q-item",
                                          {
                                            key: index,
                                            class:
                                              _vm.id === message.id
                                                ? "selected"
                                                : "",
                                            attrs: { link: "" },
                                            nativeOn: {
                                              click: function($event) {
                                                return _vm.fetchMessage(message)
                                              }
                                            }
                                          },
                                          [
                                            _c("q-item-main", {
                                              attrs: {
                                                label: message.title,
                                                sublabel: _vm.fDate(
                                                  message.send_date
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-sm-8" },
                    [
                      _c(
                        "q-card",
                        { staticClass: "full-height relative-position" },
                        [
                          _c(
                            "q-card-main",
                            { staticClass: "full-height" },
                            [
                              _c(
                                "q-scroll-area",
                                { staticClass: "full-height q-pa-xl" },
                                [
                                  _c("span", {
                                    domProps: { innerHTML: _vm._s(_vm.body) }
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-inner-loading",
                            { attrs: { visible: _vm.loading } },
                            [
                              _c("q-spinner-dots", {
                                attrs: { size: 60, color: "secondary" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_message,
            callback: function($$v) {
              _vm.show_message = $$v
            },
            expression: "show_message"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.closeMessage()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.title) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding relative-position" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("span", { domProps: { innerHTML: _vm._s(_vm.body) } })
                    ])
                  ]),
                  _c(
                    "q-inner-loading",
                    { attrs: { visible: _vm.loading } },
                    [
                      _c("q-spinner-dots", {
                        attrs: { size: 60, color: "secondary" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }